import { Button } from '@/components/ui/button';

interface PaginationProps {
  totalPages?: number;
  currentPage?: number;
  onNext?: () => void;
  onPrev?: () => void;
  onFirst?: () => void;
  onLast?: () => void;
}

export function Pagination({
  totalPages = 1,
  currentPage = 1,
  onFirst,
  onLast,
  onPrev,
  onNext,
}: PaginationProps) {
  return (
    <div className="flex items-center justify-between p-4">
      <div className="text-sm text-muted-foreground">
        Page {currentPage} of {totalPages}
      </div>
      <div className="flex gap-2">
        <Button variant="outline" size="sm" disabled={currentPage <= 1} onClick={onFirst}>
          First
        </Button>
        <Button variant="outline" size="sm" disabled={currentPage <= 1} onClick={onPrev}>
          Prev
        </Button>
        <Button variant="outline" size="sm" disabled={currentPage >= totalPages} onClick={onNext}>
          Next
        </Button>
        <Button variant="outline" size="sm" disabled={currentPage >= totalPages} onClick={onLast}>
          Last
        </Button>
      </div>
    </div>
  );
}
